import { __exports as plusOrMinusPerUnit } from './_virtual-plusOrMinusPerUnit2.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireComparativePriceFilter } from './vp-js-token-engine-build-common-filters-comparativePriceFilter.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireLocalizations } from './vp-js-token-engine-build-infrastructure-localizations.js';
import { __require as requireZeroPrice } from './vp-js-token-engine-build-filters-zeroPrice.js';

var hasRequiredPlusOrMinusPerUnit;

function requirePlusOrMinusPerUnit () {
	if (hasRequiredPlusOrMinusPerUnit) return plusOrMinusPerUnit;
	hasRequiredPlusOrMinusPerUnit = 1;

	Object.defineProperty(plusOrMinusPerUnit, "__esModule", {
	  value: true
	});
	plusOrMinusPerUnit.filter = filter;
	plusOrMinusPerUnit.name = void 0;
	requireEs_string_replace();
	var _comparativePriceFilter = requireComparativePriceFilter();
	var _container = requireContainer();
	var _localizations = requireLocalizations();
	var _zeroPrice = requireZeroPrice();
	const name = plusOrMinusPerUnit.name = 'plusOrMinusPerUnit';
	const PLUS_OR_MINUS_TEMPLATE = "<span class='swan-list-price'>{{plusOrMinusListPrice}}</span>";
	const PLUS_OR_MINUS_DISCOUNT_TEMPLATE = "<span class='swan-discount-price'>{{plusOrMinusDiscountPrice}}</span>";
	const PLUS_OR_MINUS_NO_DISCOUNT_TEMPLATE = "<span class='swan-list-price'>{{plusOrMinusDiscountPrice}}</span>";
	const PLUS_OR_MINUS_COMPARATIVE_TEMPLATE = "<span class='swan-pricing-comparison'><span class='swan-list-price'><span class='swan-visually-hidden'>{{originalPrice}}</span>{{plusOrMinusListPrice}}</span> <span class='swan-discount-price'><span class='swan-visually-hidden'>{{salePrice}}</span>{{plusOrMinusDiscountPrice}}</span></span>";
	async function filter(priceDifference, priceDifferenceDiscounted, currency, minimumFractionDigits, zeroDisplayType, comparativeDisplay) {
	  const culture = _container.contextService.getCulture(this);
	  let template = (0, _localizations.localized)(name, culture);
	  let plusOrMinusListPrice;
	  if (priceDifference !== 0) {
	    plusOrMinusListPrice = _container.formatterService.formatPriceDifference({
	      culture,
	      currency,
	      price: priceDifference,
	      minimumFractionDigits
	    });
	  } else if (priceDifferenceDiscounted !== 0) {
	    plusOrMinusListPrice = _container.formatterService.formatPriceDifference({
	      culture,
	      currency,
	      price: priceDifference,
	      minimumFractionDigits
	    });
	  } else {
	    template = (0, _localizations.localized)("".concat(name, ".base"), culture);
	    plusOrMinusListPrice = (0, _localizations.localized)("".concat(name, ".subtemplate"), culture);
	  }
	  const mustacheVariables = {
	    plusOrMinusListPrice
	  };
	  const htmlTemplates = {
	    plusOrMinus: PLUS_OR_MINUS_TEMPLATE
	  };
	  if (comparativeDisplay === undefined || comparativeDisplay === _comparativePriceFilter.ComparativeDisplayType.Legacy) {
	    comparativeDisplay = _comparativePriceFilter.ComparativeDisplayType.Never;
	  }
	  if (priceDifferenceDiscounted !== priceDifference) {
	    if ((0, _comparativePriceFilter.shouldShowComparative)(priceDifference, priceDifferenceDiscounted, comparativeDisplay)) {
	      htmlTemplates.plusOrMinus = PLUS_OR_MINUS_COMPARATIVE_TEMPLATE;
	      mustacheVariables['originalPrice'] = (0, _localizations.localized)('originalPrice', culture);
	      mustacheVariables['salePrice'] = (0, _localizations.localized)('salePrice', culture);
	    } else if ((0, _comparativePriceFilter.isPriceDiscounted)(priceDifference, priceDifferenceDiscounted)) {
	      htmlTemplates.plusOrMinus = PLUS_OR_MINUS_DISCOUNT_TEMPLATE;
	    } else {
	      htmlTemplates.plusOrMinus = PLUS_OR_MINUS_NO_DISCOUNT_TEMPLATE;
	    }
	    const plusOrMinusDiscountPrice = _container.formatterService.formatPriceDifference({
	      culture,
	      currency,
	      price: priceDifferenceDiscounted,
	      minimumFractionDigits
	    });
	    mustacheVariables['plusOrMinusDiscountPrice'] = plusOrMinusDiscountPrice;
	  }
	  if (priceDifference === 0 && priceDifferenceDiscounted === 0 && zeroDisplayType !== undefined && zeroDisplayType !== _zeroPrice.ZeroDisplayType.Legacy) {
	    return (0, _zeroPrice.getZeroDisplayMessage)(culture, currency, minimumFractionDigits, zeroDisplayType);
	  }
	  return _container.mustacheService.replace(template, mustacheVariables, htmlTemplates);
	}
	
	return plusOrMinusPerUnit;
}

export { requirePlusOrMinusPerUnit as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-plusOrMinusPerUnit.js.map
